<template>
  <div class="rank-com">
    <!-- <TxBg src="rank_beijing-liebiao" class="center"> -->
    <TxBg src="oldclassic_p_home_beijin3" class="center">
      <div class="pc-empty"></div>
      <search class="rank-search" />
      <query @do_query="do_query" :default_values="default_values" />

      <TxBg src="rank_liebiaodiban" class="center">
        <div class="table-com">
          <tx-table :columns="columns" :data="ranks"></tx-table>
        </div>
      </TxBg>

      <TxPagination
        @pageChange="pageChange"
        v-model:page="page"
        :total="total"
        :size="size"
      />
    </TxBg>

    <Link />
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
const { is_mobile, schools, sectors } = inject('GlobalStore');
import { get_rank } from '@utils/api';
import query from './components/rank/query.vue';
import search from './components/search.vue';
import Link from './components/link.vue';
import { goBack } from '@utils/goBack';
import eventEmitter from '@utils/event';

const router = useRouter();
const route = useRoute();
const ranks = ref([]);

const total = ref(0);
const size = ref(20);
const page = ref(1);

const default_values = computed(() => route.query);

const columns = ref([
  {
    title: '排名',
    key: 'rank',
    stylehead: 'font-size:20px;color:red;font-weight:bolder;',
    stylecolumn: 'font-size:10px;color:blue;',
  },
  {
    title: '角色',
    key: 'role',
    render: ({ row }) => {
      return h(
        'a',
        {
          class: 'pointer',
          onClick: () => roleClick(row),
        },
        row.role
      );
    },
  },
  // {
  //   title: '大区',
  //   key: 'server',
  //   render: ({ row }) => {
  //     const name = sector_name(row.server);
  //     return h('span', {}, name);
  //   },
  // },
  {
    title: '服务器',
    key: 'server',
    render: ({ row }) => {
      const name = server_name(row.server);
      return h('span', {}, name);
    },
  },
  {
    title: '等级',
    key: 'level',
  },
  {
    title: '门派',
    key: 'school',
    render: ({ row }) => {
      const _shcool_name = shcool_name(row.school);
      return h('span', {}, _shcool_name);
    },
  },
  {
    title: '势力',
    key: 'clan',
    render: ({ row }) => {
      return h(
        'a',
        {
          class: 'pointer',
          onClick: () => clanClick(row),
        },
        row.clan
      );
    },
  },
  {
    title: '人物修为',
    key: 'xiuwei',
  },
  {
    title: '装备评价',
    key: 'equ_xiuwei',
  },
  {
    title: '总修为',
    key: 'total_xiuwei',
  },
  // {
  //   title: '风华值',
  //   key: 'fenghua',
  // },
]);

const params = computed(() => route.query);

const load_rank = (_params = {}) => {
  get_rank({ page: page.value, ...params.value, ..._params }).then((res) => {
    console.log('get_rank测试', res);
    if (res.code == 0) {
      ranks.value = [...res.data.ranks];
      total.value = res.data.page_info.total;
      size.value = res.data.page_info.size;
      page.value = res.data.page_info.page;
    } else {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
        duration: 5,
      });
    }
  });
};

onMounted(() => {
  console.log('params', params.value);
  // default_values.value = {...{
  //   school: params.value.school || '',
  //   server: params.value.server || '',
  //   order_key: params.value.order_key || 'total_xiuwei',
  // }};

  load_rank(params.value);
});

const shcool_name = (shcool_id) => {
  return schools.value[shcool_id];
};

const sector_name = (server) => {
  return sectors.value[server] || '';
};

const server_name = (server) => {
  return sectors.value[server]?.name || server;
};

const roleClick = (record) => {
  const routeData = {
    path: `/role`,
    query: {
      key: record.key,
    },
  };
  // 解析路由获取完整 URL
  const resolved = router.resolve(routeData);
  const fullUrl = window.location.origin + resolved.href;

  // 在新标签页打开
  window.open(fullUrl, '_blank');
  // router.push({
  //   // path: `/role/${record.key}`,
  //   path: `/role`,
  //   query: {
  //     key: record.key,
  //     // tab: tab,
  //     // from: 'dashboard'
  //   },
  // });
};

const clanClick = (record) => {
  console.log('clanClick', record);
};

const pageChange = (page) => {
  load_rank({ page });
};

const do_query = (filter_op) => {
  const newQuery = { ...route.query, ...filter_op };
  router.replace({
    path: `/rank`,
    query: newQuery,
  });
  load_rank(filter_op);
};
</script>

<style lang="scss" scoped postcss="false">
.pc-empty {
  width: 300px;
  height: 240px;
}
</style>